import { Badge, BadgeProps } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { Camera } from '@/types/camera'

const messageMap = {
  rtsp: {
    id: 'cameras.type.rtsp',
    color: 'brand-primary'
  },
  usb: {
    id: 'cameras.type.usb',
    color: 'brand-secondary'
  }
}

type CameraTypeBadgeProps = {
  type: Camera['stream_type']
  size?: BadgeProps['size']
}

export const CameraTypeBadge = ({
  type,
  size = 'xs'
}: CameraTypeBadgeProps) => {
  const settings = messageMap[type]

  if (settings) {
    return (
      <Badge size={size} color={settings.color}>
        <FormattedMessage id={settings.id} />
      </Badge>
    )
  }

  return null
}
